import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { IAskRequest, IAskResponse } from "./types"

export const askSupport = (data: IAskRequest): Promise<AxiosResponse<IAskResponse>> => {
    return apiInstance.handler.post<IAskResponse>('/support/ask', data)
}

